export function CartHeader({ action = true }) {
    return (
        <div className="w-full flex flex-wrap items-center gap-1 mb-6 pb-2 border-b border-gray-200">
            <div className="flex flex-col flex-grow">
                <span className="block truncate text-sm text-gray-500 w-20 text-left">
                    Item
                </span>
            </div>
            <div className="flex items-center justify-end gap-1">
                <span className="block truncate text-sm text-gray-500 w-20 text-right">
                    Unit
                </span>
                <span className="block truncate text-sm text-gray-500 w-20 text-right">
                    Quantity
                </span>
                <span className="block truncate text-sm text-gray-500 w-20 text-right">
                    Total
                </span>
                {action && (
                    <span className="block truncate text-sm text-gray-500 w-28 text-right">
                        Action
                    </span>
                )}
            </div>
        </div>
    )
}
